export default "$ yarn add @mdi/font -D\n// OR\n$ npm install @mdi/font -D\n";